<template>
  <PageShell :active="active">
    <section class="text-page">
      <h1>{{ articles.title }}</h1>
      <div class="content" v-loading="loading">
        <div class="rich-content" v-html="richContent"></div>
      </div>
    </section>
  </PageShell>
</template>

<script>
import PageShell from '@/components/common/PageShell.vue'

export default {
  name: 'TextPage',
  components: {
    PageShell
  },
  data() {
    return {
      articles: {},
      loading: false
    }
  },
  computed: {
    richContent() {
      const content = this.articles.content || ''
      if (!content.includes('cookiesConsentPref')) return content

      // v-html 不会编译 Vue 指令，使用原生 checkbox 实现鼠标和键盘切换。
      const container = document.createElement('div')
      container.innerHTML = content
      const rows = container.querySelectorAll('#cookiesConsentPref .cookie-type')
      rows.forEach((row, index) => {
        const header = row.querySelector('.cookie-header')
        const originalSwitch = header && header.lastElementChild
        if (!originalSwitch || originalSwitch.classList.contains('cookie-title-group')) return

        const essential = row.dataset.type
          ? row.dataset.type === 'gdpr_cookies_essential'
          : index === 0
        const label = document.createElement('label')
        label.className = 'switch'
        const checkbox = document.createElement('input')
        checkbox.type = 'checkbox'
        checkbox.className = 'cookie-checkbox'
        checkbox.setAttribute('role', 'switch')
        checkbox.setAttribute('aria-label', row.querySelector('.cookie-title')?.textContent.trim() || 'Cookies')
        checkbox.setAttribute('checked', '')
        if (essential) checkbox.disabled = true

        const slider = document.createElement('span')
        slider.className = 'cookie-slider'
        slider.setAttribute('aria-hidden', 'true')
        label.appendChild(checkbox)
        label.appendChild(slider)
        header.replaceChild(label, originalSwitch)
      })
      return container.innerHTML
    }
  },
  mounted() {
    this.loadArticle()
  },
  watch: {
    '$route.query.id': function () {
      this.loadArticle()
    }
  },
  methods: {
    async loadArticle() {
      this.loading = true
      const id = this.$route.query.id || '4'
      try {
        const res = await this.$api({
          url: 'Content/articleDetail',
          method: 'get',
          data: { id: Number(id) }
        })
        this.articles = res.data || {}
      } catch (e) {
        // keep placeholder content on failure
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.text-page {
  max-width: 1100px;
  min-height: 900px;
  margin: 0 auto;
  padding: 34px 20px 80px;
}

h1 {
  margin: 0 0 34px;
  font-size: 28px;
  font-weight: 400;
}


</style>

<style>
/* v-html 内的节点没有 scoped 属性；限定在当前页面内覆盖富文本内联样式。 */
.text-page .rich-content #cookiesConsentPref .cookie-toggle-wrapper {
  overflow: hidden;
  margin: 10px 0 !important;
  background: #f5f5f5 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1) !important;
}

.text-page .rich-content #cookiesConsentPref .cookie-type {
  box-sizing: border-box;
  padding: 17px 18px !important;
  border-bottom: 1px solid #eeeeee !important;
}

.text-page .rich-content #cookiesConsentPref .cookie-type:last-child {
  border-bottom: 0 !important;
}

.text-page .rich-content #cookiesConsentPref .cookie-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 16px;
  margin-bottom: 8px !important;
}

.text-page .rich-content #cookiesConsentPref .cookie-title-group {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap;
  gap: 10px !important;
  min-width: 0;
}

.text-page .rich-content #cookiesConsentPref .cookie-title {
  color: #000000;
  font-size: 16px !important;
  font-weight: 400;
  line-height: 24px;
}

.text-page .rich-content #cookiesConsentPref .cookie-required {
  padding: 2px 7px !important;
  color: #888888 !important;
  background: #eeeeee !important;
  border-radius: 12px !important;
  font-size: 12px !important;
  line-height: 18px;
  white-space: nowrap;
}

.text-page .rich-content #cookiesConsentPref .cookie-description {
  margin: 0 !important;
  padding: 0 !important;
  color: #888888 !important;
  font-size: 14px !important;
  line-height: 22px;
}

.text-page .rich-content #cookiesConsentPref .cookie-description span {
  color: inherit !important;
  font-size: inherit !important;
  line-height: inherit !important;
}

/* 纯样式版 div 和原有开关统一为原生 checkbox + slider。 */
.text-page .rich-content #cookiesConsentPref .switch {
  position: relative !important;
  display: inline-block !important;
  flex: 0 0 44px;
  width: 44px !important;
  height: 28px !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  border-radius: 28px !important;
  background: transparent !important;
  vertical-align: middle;
}

.text-page .rich-content #cookiesConsentPref .switch .cookie-checkbox {
  position: absolute;
  z-index: 1;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  opacity: 0;
  cursor: pointer;
}

.text-page .rich-content #cookiesConsentPref .cookie-slider {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: #cccccc;
  transition: background-color 0.2s;
}

.text-page .rich-content #cookiesConsentPref .switch::before,
.text-page .rich-content #cookiesConsentPref .switch::after {
  content: none !important;
}

.text-page .rich-content #cookiesConsentPref .cookie-slider::before {
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ffffff;
  transition: transform 0.2s;
}

.text-page .rich-content #cookiesConsentPref .cookie-checkbox:checked + .cookie-slider {
  background: #2196f3;
}

.text-page .rich-content #cookiesConsentPref .cookie-checkbox:checked + .cookie-slider::before {
  transform: translateX(16px);
}

.text-page .rich-content #cookiesConsentPref .cookie-checkbox:disabled + .cookie-slider {
  background: #8bc8f8;
}

.text-page .rich-content #cookiesConsentPref .cookie-checkbox:disabled {
  cursor: not-allowed;
}

.text-page .rich-content #cookiesConsentPref .cookie-checkbox:focus-visible + .cookie-slider {
  outline: 2px solid #2196f3;
  outline-offset: 3px;
}
</style>
